module.exports = __webpack_public_path__ + "img/p1.35fffcd2.jpg";